import Template, {TextInput} from "../../../../models/Template";
import React from "react";
import {useTemplate} from "../../../../context/TemplateContext";

export const useContentEditable = (template: Template | undefined) => {
    const {setSelectedContentEditable, setSelectedTransformedImage} = useTemplate();
    const inputs = template?.inputs

    const applyContentEditable = (
        container: HTMLDivElement,
        handleChangeText: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, key: string) => void
    ) => {
        // make the text inputs content editable
        const editableInputs = Object.keys(inputs!)
            .filter(key => {
                const input = inputs![key];
                return input.editable && input.type == "text"
            });

        [...container.querySelectorAll<HTMLElement>('[data-name]')]
            .filter(node => editableInputs.includes(node.getAttribute('data-name')!))
            .forEach(node => {
                const inputKey = node.getAttribute('data-name')!

                node.contentEditable = "true"
                node.oninput = (event) => {
                    const reactEvent = event as unknown as React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
                    handleMaxChars(reactEvent, inputKey);
                    handleChangeText(reactEvent, inputKey);
                };

                node.onkeypress = (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        document.execCommand('insertLineBreak')
                        node.dispatchEvent(new Event('input', {bubbles: true}));
                    }
                };

                node.onpaste = (event) => {
                    handlePaste(
                        event as unknown as React.ClipboardEvent<HTMLDivElement>,
                        node.getAttribute('data-name')!
                    )
                }
                node.onfocus = () => {
                    setSelectedContentEditable(inputKey);
                    setSelectedTransformedImage(undefined)
                };
                node.onblur = () => {
                    setSelectedContentEditable(undefined);
                };
            })
    }

    function handleMaxChars(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>, key: string) {
        // console.log("handleChangeText", key, event)
        const textContent = event.currentTarget.textContent;
        const input = inputs![key] as TextInput
        const maxChars = input.maxChars
        if ((textContent?.length ?? 0) > maxChars) {
            // Prevent further input if the limit is reached
            event.currentTarget.textContent = textContent!.substring(0, maxChars);
            // Move the cursor to the end
            document.getSelection()!.collapse(event.currentTarget, 1);
        }
    }

    const handlePaste = (event: React.ClipboardEvent<HTMLDivElement>, key: string) => {
        event.preventDefault();
        const input = inputs![key] as TextInput
        const maxChars = input.maxChars
        const text = event.clipboardData.getData('text').slice(0, maxChars);
        document.execCommand('insertText', false, text);
    };

    return {applyContentEditable};
};
